var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e14917ee502c32dd93648c31b3b7a6204230da73"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["umb@umb"]={id:"e14917ee502c32dd93648c31b3b7a6204230da73"};
      